import { useTranslation } from 'react-i18next'

import { Player } from '@lottiefiles/react-lottie-player'

import CalendarLottie from 'shared/json/calendarLottie.json'

import s from './styles.module.scss'

export const PriceTimelinePopup = () => {
  const { t } = useTranslation()
  return (
    <div className={s.timelinePopup}>
      <div className={s.image}>
        <Player
          src={CalendarLottie}
          loop
          autoplay
          renderer={'svg'}
        />
      </div>

      <div className={s.text}>
        <h3 className={s.title}>{t('priceTimelinePopup.title')}</h3>

        <p className={s.description}>{t('priceTimelinePopup.description')}</p>
      </div>
    </div>
  )
}
